// roles vs profiles: rol es el papel que despeña,
// perfil es conjunto de permisos
const reviewerRoles = {
    health: 'Especialista de Salud',
    safety: 'Especialista de Seguridad',
    environment: 'Especialista de Medioambiente',
    contractor_hse: 'HSE Contratista',
    contract_owner: 'Dueño de Contrato',
    administrator: 'Administrador de Contrato',
    hse: 'HSE',
    owner: 'Dueño de Contrato',
    risk: 'Especialista de Riesgo',
    manager: 'Gerente',
    super: 'Superintendente',
    general_manager: 'Gerente General',
    superadmin: 'Administrador del sistema',
};

const coordinatorRoles = {
    contractor_coordinator: 'Coordinador Contratista',
    coordinator: 'Coordinador',
};

const Roles = Object.assign(
    Object.assign({}, coordinatorRoles),
    reviewerRoles,
);

const contractorRoles = {
    contractor_hse: 'HSE Contratista',
    contract_owner: 'Dueño de Contrato',
    administrator: 'Administrador de Contrato',
    contractor_coordinator: 'Coordinador Contratista',
};

const bhpProfiles = {
    hse: 'HSE',
    health: 'Especialista de Salud',
    safety: 'Especialista de Seguridad',
    environment: 'Especialista de Medioambiente',
    contractor_hse: 'HSE Contratista',
    owner: 'Dueño de Contrato',
    contract_owner: 'Dueño de Contrato',
    risk: 'Especialista de Riesgo',
    administrator: 'Administrador de Contrato',
    contractor_coordinator: 'Coordinador Contratista',
    coordinator: 'Coordinador',
    manager: 'Gerente',
    super: 'Superintendente',
    general_manager: 'Gerente General',
    superadmin: 'Administrador del sistema'
};

export {
    Roles,
    contractorRoles,
    reviewerRoles,
    coordinatorRoles,
    bhpProfiles,
};